import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row w-100 d-flex justify-content-between align-items-center" }
const _hoisted_2 = { class: "col-11 w-100 p-0" }
const _hoisted_3 = { class: "col-1 w-100 p-0" }

import { coreApi } from '@/conection';
import { AlertModule } from '@/store/modules/Alert';
import { TicketModule } from '@/store/modules/Ticket';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  emits: ["showClientName"],
  setup(__props, { emit: emits }) {

const regex = /^[a-záéíóú]{3,}$/i

const name = ref(TicketModule.currentTicket?.client[0].customer.first_name ?? "");
const lastname = ref(TicketModule.currentTicket?.client[0].customer.last_name ?? "");



function onSubmit() {
	name.value = name.value.trim()
	lastname.value = lastname.value.trim()
	if(!(regex.test(name.value) && regex.test(lastname.value))) {
		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: "Debe ingresar solo un nombre y un apellido, sin caracteres especiales ni números. Mínimo tres letras",
			type: "error",
		});
		return
	}

	const payload = {
		ticketID: TicketModule.currentRoomID,
		client: TicketModule.currentTicket?.client[0]._id,
		first_name: name.value.charAt(0).toUpperCase() + name.value.slice(1).toLowerCase(),
		last_name: lastname.value.charAt(0).toUpperCase() + lastname.value.slice(1).toLowerCase()
	}

	coreApi.post("/api/client/update-name", payload).then(() => {
		emits('showClientName')
	})
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        name: "name",
        class: "pl-1 mb-1",
        placeholder: "Primer Nombre",
        modelValue: name.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
        size: "small",
        "validate-event": false,
        alternative: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        name: "lastname",
        class: "pl-1",
        placeholder: "Primer Apellido",
        modelValue: lastname.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((lastname).value = $event)),
        size: "small",
        alternative: ""
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_tooltip, {
        content: "Guardar",
        placement: "left"
      }, {
        default: _withCtx(() => [
          _createElementVNode("i", {
            class: "col-6 fa fa-save fa-xs color-regular save-button",
            onClick: onSubmit
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_tooltip, {
        content: "Cancelar",
        placement: "left"
      }, {
        default: _withCtx(() => [
          _createElementVNode("i", {
            class: "col-6 fa fa-window-close fa-xs color-regular x-button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('showClientName')))
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})